import { deriveCredential } from '@trustvc/w3c-vc';
import { verifyW3CSignature } from '../../../w3c/verify';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const PROOF_TYPE = "DataIntegrityProof";
const DERIVE_CREDENTIAL_ERROR = "Use deriveCredential() first";
function isSignedVerifiableCredential(document) {
  return typeof document === "object" && document !== null && "proof" in document;
}
__name(isSignedVerifiableCredential, "isSignedVerifiableCredential");
function createW3CSignatureIntegrityVerifier(config) {
  const { cryptosuite, name, derivationPaths = [] } = config;
  return {
    skip: /* @__PURE__ */ __name(async () => {
      return {
        type: "DOCUMENT_INTEGRITY",
        name,
        reason: {
          code: 0,
          codeString: "SKIPPED",
          message: `Document either has no proof or proof type is not '${PROOF_TYPE}' or proof cryptosuite is not '${cryptosuite}'.`
        },
        status: "SKIPPED"
      };
    }, "skip"),
    test: /* @__PURE__ */ __name((document) => {
      const doc = document;
      return doc.proof?.type === PROOF_TYPE && doc.proof?.cryptosuite === cryptosuite;
    }, "test"),
    verify: /* @__PURE__ */ __name(async (document, verifierOptions) => {
      if (!isSignedVerifiableCredential(document)) {
        return {
          type: "DOCUMENT_INTEGRITY",
          name,
          data: false,
          reason: {
            message: "Document is not a valid SignedVerifiableCredential"
          },
          status: "INVALID"
        };
      }
      try {
        let verificationResult = await verifyW3CSignature(document, verifierOptions);
        let isDerived = true;
        if (!verificationResult.verified && verificationResult.error?.includes(DERIVE_CREDENTIAL_ERROR)) {
          const derivedCredential = await deriveCredential(document, derivationPaths);
          verificationResult = await verifyW3CSignature(derivedCredential.derived, verifierOptions);
          isDerived = false;
        }
        if (verificationResult.verified) {
          return {
            type: "DOCUMENT_INTEGRITY",
            name,
            data: true,
            reason: {
              message: isDerived ? "Document verified successfully" : "Document verified after derivation"
            },
            status: "VALID"
          };
        } else {
          return {
            type: "DOCUMENT_INTEGRITY",
            name,
            data: false,
            reason: {
              message: verificationResult.error || "Verification failed"
            },
            status: "INVALID"
          };
        }
      } catch (error) {
        return {
          type: "DOCUMENT_INTEGRITY",
          name,
          data: false,
          reason: {
            message: error instanceof Error ? error.message : "Unknown verification error"
          },
          status: "INVALID"
        };
      }
    }, "verify")
  };
}
__name(createW3CSignatureIntegrityVerifier, "createW3CSignatureIntegrityVerifier");

export { createW3CSignatureIntegrityVerifier };
